import { STORAGE_KEYS } from '../constants';

export const login = (user, rememberMe) => {
  if (rememberMe) {
    localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user));
    localStorage.setItem(STORAGE_KEYS.rememberMe, 'true');
  } else {
    sessionStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user));
    localStorage.removeItem(STORAGE_KEYS.rememberMe);
  }
  return user;
};

export const logout = () => {
  localStorage.removeItem(STORAGE_KEYS.user);
  sessionStorage.removeItem(STORAGE_KEYS.user);
};

export const signup = (userData) => {
  // In a real app, you would make an API call here
  // This is a mock implementation
  return {
    id: Math.random().toString(36).substr(2, 9),
    ...userData,
  };
};


export function getActionsForMenu(menuKey,permissions) {

return permissions?.reduce((acc, perm) => {
  const prefix = `Menu_${menuKey}_`;
  if (perm.startsWith(prefix)) {
    const action = perm.slice(prefix.length);
    acc.push(action);
  }
  return acc;
}, []);  
}